import React from 'react';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Youtube } from 'lucide-react';
import { shopInfo, shopLogo, brands } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', href: '#home' },
    { name: 'Our Brands', href: '#brands' },
    { name: 'Products', href: '#products' },
    { name: 'Services', href: '#services' },
    { name: 'About Us', href: '#about' },
    { name: 'Contact', href: '#contact' }
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1e1919] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-lg overflow-hidden bg-white">
                <img 
                  src={shopLogo} 
                  alt={shopInfo.name}
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <h3 className="font-bold text-white">{shopInfo.name}</h3>
                <p className="text-xs text-[#bbb5ae]">IT Solutions & Support</p>
              </div>
            </div>
            <p className="text-[#bbb5ae] text-sm leading-relaxed mb-4">
              Your trusted IT support and electronics solutions provider in Jassur since 2001. Quality products, expert service, and 24+ years of experience.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 rounded-lg bg-white/10 hover:bg-[#2563eb] flex items-center justify-center transition-colors duration-200">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-lg bg-white/10 hover:bg-[#2563eb] flex items-center justify-center transition-colors duration-200">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-lg bg-white/10 hover:bg-[#2563eb] flex items-center justify-center transition-colors duration-200">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-[#bbb5ae] hover:text-white text-sm transition-colors duration-200"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Our Brands */}
          <div>
            <h4 className="font-semibold text-white mb-4">Our Brands</h4>
            <ul className="space-y-2">
              {brands.map((brand) => (
                <li key={brand.id}>
                  <span className="text-[#bbb5ae] text-sm">{brand.name}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-white mb-4">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#2563eb] flex-shrink-0 mt-0.5" />
                <span className="text-[#bbb5ae] text-sm">{shopInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#2563eb] flex-shrink-0" />
                <a href={`tel:${shopInfo.phone}`} className="text-[#bbb5ae] hover:text-white text-sm transition-colors">
                  {shopInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#2563eb] flex-shrink-0" />
                <a href={`mailto:${shopInfo.email}`} className="text-[#bbb5ae] hover:text-white text-sm transition-colors break-all">
                  {shopInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-[#2563eb] flex-shrink-0 mt-0.5" />
                <div className="text-[#bbb5ae] text-sm">
                  <p>Mon-Sat: {shopInfo.openingHours.weekdays}</p>
                  <p>Sun: {shopInfo.openingHours.sunday}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-[#bbb5ae] text-sm text-center md:text-left">
              © {currentYear} {shopInfo.name}. All rights reserved.
            </p>
            <p className="text-[#bbb5ae] text-sm">
              Canon Pixma Zone • Genuine Products • Expert Support
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
